import './index.scss';
import React, { useRef } from 'react';
import { List, NavBar, Icon, InputItem, Button, Toast } from 'antd-mobile';
import { checkPass, modifyPass } from '../../services/tscloud/user';
import { updatePassword } from '../../services/saas/user';
import { getUser } from '../../utils/index';
import { getPlatConfig, getBooleanValue } from '../../utils';
import { useHistory } from 'react-router';

async function modifyTscloud(originPass, newPass, verification, history) {
  const { userId, loginName } = getUser() || {};
  if (!originPass) {
    Toast.info('请输入原密码');
    return;
  }
  try {
    const check = await checkPass({
      password: encodeURIComponent(originPass),
      loginName,
      uuid: userId,
    });
    if (check && check.res !== 1) {
      Toast.info('原密码错误');
      return;
    }
    if (!newPass) {
      Toast.info('请输入新密码');
      return;
    }
    if (!(newPass.length >= 8 && newPass.length <= 20)) {
      Toast.info('密码格式错误！请输入8-20字符');
      return;
    }
    if (!verification) {
      Toast.info('请输入确认密码');
      return;
    }
    if (newPass !== verification) {
      Toast.info('两次密码输入不一致');
      return;
    }
    const modify = await modifyPass({
      password: encodeURIComponent(newPass),
      loginName,
      uuid: userId,
    });
    if (modify && modify.res === 1) {
      Toast.success('修改成功');
      history.goBack();
    }
  } catch (err) {
    Toast.info(err);
  }
}

async function modifySass(originPass, newPass, verification, history) {
  // eslint-disable-next-line no-useless-escape
  var reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W\_]).{8,}$/;
  if (!originPass) {
    Toast.info('请输入原密码');
    return;
  }
  if (!newPass) {
    Toast.info('请输入新密码');
    return;
  }
  if (!reg.test(newPass)) {
    Toast.info('密码必须包含数字、英文字母和特殊字符，且不低于8位');
    return;
  }
  if (!verification) {
    Toast.info('请输入确认密码');
    return;
  }
  if (newPass !== verification) {
    Toast.info('两次密码输入不一致');
    return;
  }
  try {
    const modify = await updatePassword({
      oldPassword: originPass,
      newPassword: newPass,
      newPassword1: verification,
    });
    if (modify && modify.success) {
      Toast.success('修改成功');
      history.goBack();
    } else {
      Toast.success(modify.msg || '修改失败');
    }
  } catch (err) {
    Toast.info(err);
  }
}

function handleModify(originPass, newPass, verification, history) {
  const { platformType } = getPlatConfig() || {};
  if (platformType === 'saas') {
    modifySass(originPass, newPass, verification, history);
  } else {
    modifyTscloud(originPass, newPass, verification, history);
  }
}

function ModifyPass() {
  const originPass = useRef();
  const newPass = useRef();
  const verification = useRef();
  const history = useHistory();
  return (
    <div className="modify-password">
      <NavBar
        mode="light"
        icon={<Icon type="left" />}
        onLeftClick={() => history.goBack()}
        style={
          getBooleanValue('IS_IMMERSE', false)
            ? { marginBottom: '5vw', paddingTop: '6vw', height: '18vw' }
            : { marginBottom: '5vw', height: '12vw' }
        }
      >
        修改密码
      </NavBar>
      <List>
        <InputItem
          ref={originPass}
          placeholder="请输入原密码"
          type="password"
          className="input-item"
        >
          原密码
        </InputItem>
        <InputItem ref={newPass} placeholder="请输入新密码" type="password" className="input-item">
          新密码
        </InputItem>
        <InputItem
          ref={verification}
          placeholder="请确认新密码"
          type="password"
          className="input-item"
        >
          确认密码
        </InputItem>
      </List>
      <Button
        type="primary"
        style={{ margin: '10vw 3vw 0' }}
        onClick={() =>
          handleModify(
            originPass.current.state.value,
            newPass.current.state.value,
            verification.current.state.value,
            history,
          )
        }
      >
        确定
      </Button>
    </div>
  );
}

export default ModifyPass;
